/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiIntegrationsDeleteAnthropicInferenceConfig } from "../funcs/aiIntegrationsDeleteAnthropicInferenceConfig.js";
import { aiIntegrationsDeleteConfig } from "../funcs/aiIntegrationsDeleteConfig.js";
import { aiIntegrationsGetAnthropicInferenceConfig } from "../funcs/aiIntegrationsGetAnthropicInferenceConfig.js";
import { aiIntegrationsGetConfig } from "../funcs/aiIntegrationsGetConfig.js";
import { aiIntegrationsListSchedules } from "../funcs/aiIntegrationsListSchedules.js";
import { aiIntegrationsRetrySchedule } from "../funcs/aiIntegrationsRetrySchedule.js";
import { aiIntegrationsSetScheduleEnabled } from "../funcs/aiIntegrationsSetScheduleEnabled.js";
import { aiIntegrationsUpsertAnthropicInferenceConfig } from "../funcs/aiIntegrationsUpsertAnthropicInferenceConfig.js";
import { aiIntegrationsUpsertConfig } from "../funcs/aiIntegrationsUpsertConfig.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AIIntegrationConfig } from "../models/components/aiintegrationconfig.js";
import { AIIntegrationScheduleState } from "../models/components/aiintegrationschedulestate.js";
import { AnthropicInferenceConfig } from "../models/components/anthropicinferenceconfig.js";
import { ListAIIntegrationSchedulesResult } from "../models/components/listaiintegrationschedulesresult.js";
import {
  DeleteAIIntegrationConfigRequest,
  DeleteAIIntegrationConfigSecurity,
} from "../models/operations/deleteaiintegrationconfig.js";
import {
  DeleteAnthropicInferenceConfigRequest,
  DeleteAnthropicInferenceConfigSecurity,
} from "../models/operations/deleteanthropicinferenceconfig.js";
import {
  GetAIIntegrationConfigRequest,
  GetAIIntegrationConfigSecurity,
} from "../models/operations/getaiintegrationconfig.js";
import {
  GetAnthropicInferenceConfigRequest,
  GetAnthropicInferenceConfigSecurity,
} from "../models/operations/getanthropicinferenceconfig.js";
import {
  ListAIIntegrationSchedulesRequest,
  ListAIIntegrationSchedulesSecurity,
} from "../models/operations/listaiintegrationschedules.js";
import {
  RetryAIIntegrationScheduleRequest,
  RetryAIIntegrationScheduleSecurity,
} from "../models/operations/retryaiintegrationschedule.js";
import {
  SetAIIntegrationScheduleEnabledRequest,
  SetAIIntegrationScheduleEnabledSecurity,
} from "../models/operations/setaiintegrationscheduleenabled.js";
import {
  UpsertAIIntegrationConfigRequest,
  UpsertAIIntegrationConfigSecurity,
} from "../models/operations/upsertaiintegrationconfig.js";
import {
  UpsertAnthropicInferenceConfigRequest,
  UpsertAnthropicInferenceConfigSecurity,
} from "../models/operations/upsertanthropicinferenceconfig.js";
import { unwrapAsync } from "../types/fp.js";

export class AiIntegrations extends ClientSDK {
  /**
   * deleteAnthropicInferenceConfig aiIntegrations
   *
   * @remarks
   * Disconnect the organization Anthropic inference hook and revoke its URL.
   */
  async deleteAnthropicInferenceConfig(
    request?: DeleteAnthropicInferenceConfigRequest | undefined,
    security?: DeleteAnthropicInferenceConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(aiIntegrationsDeleteAnthropicInferenceConfig(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteConfig aiIntegrations
   *
   * @remarks
   * Delete the org-wide AI integration config for a provider.
   */
  async deleteConfig(
    request: DeleteAIIntegrationConfigRequest,
    security?: DeleteAIIntegrationConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(aiIntegrationsDeleteConfig(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getAnthropicInferenceConfig aiIntegrations
   *
   * @remarks
   * Get the organization Anthropic inference hook setup.
   */
  async getAnthropicInferenceConfig(
    request?: GetAnthropicInferenceConfigRequest | undefined,
    security?: GetAnthropicInferenceConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AnthropicInferenceConfig> {
    return unwrapAsync(aiIntegrationsGetAnthropicInferenceConfig(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getConfig aiIntegrations
   *
   * @remarks
   * Get the org-wide AI integration config for a provider. Returns an empty config (enabled=false, has_api_key=false) when none is set.
   */
  async getConfig(
    request: GetAIIntegrationConfigRequest,
    security?: GetAIIntegrationConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AIIntegrationConfig> {
    return unwrapAsync(aiIntegrationsGetConfig(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listSchedules aiIntegrations
   *
   * @remarks
   * List the sync schedules and their scheduler state for a provider's org-wide AI integration config. Returns an empty list when no config is set.
   */
  async listSchedules(
    request: ListAIIntegrationSchedulesRequest,
    security?: ListAIIntegrationSchedulesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAIIntegrationSchedulesResult> {
    return unwrapAsync(aiIntegrationsListSchedules(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * retrySchedule aiIntegrations
   *
   * @remarks
   * Make one sync schedule due immediately, lifting any automatic pause and resetting its failure streak. The scheduler picks it up on its next tick.
   */
  async retrySchedule(
    request: RetryAIIntegrationScheduleRequest,
    security?: RetryAIIntegrationScheduleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AIIntegrationScheduleState> {
    return unwrapAsync(aiIntegrationsRetrySchedule(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setScheduleEnabled aiIntegrations
   *
   * @remarks
   * Enable or disable one sync schedule of a provider's org-wide AI integration config. Disabled schedules are skipped by the poller until re-enabled.
   */
  async setScheduleEnabled(
    request: SetAIIntegrationScheduleEnabledRequest,
    security?: SetAIIntegrationScheduleEnabledSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AIIntegrationScheduleState> {
    return unwrapAsync(aiIntegrationsSetScheduleEnabled(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertAnthropicInferenceConfig aiIntegrations
   *
   * @remarks
   * Prepare a webhook URL or update its signing secret and enabled state.
   */
  async upsertAnthropicInferenceConfig(
    request: UpsertAnthropicInferenceConfigRequest,
    security?: UpsertAnthropicInferenceConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AnthropicInferenceConfig> {
    return unwrapAsync(aiIntegrationsUpsertAnthropicInferenceConfig(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertConfig aiIntegrations
   *
   * @remarks
   * Create or update the org-wide AI integration config for a provider.
   */
  async upsertConfig(
    request: UpsertAIIntegrationConfigRequest,
    security?: UpsertAIIntegrationConfigSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AIIntegrationConfig> {
    return unwrapAsync(aiIntegrationsUpsertConfig(
      this,
      request,
      security,
      options,
    ));
  }
}
